<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { formatNumber, getStr, globalCurrencyTag } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import { selectedGiftGroup, selectedGifts } from '../store/pdp_store';
  import { getAppConfig } from '../../../common/config/app-config';
  export let freeGiftDataList;

  const { lang } = getAppConfig();
  const isFreeGiftDataList = Array.isArray(freeGiftDataList);

  $: isDiscountAvailable =
    isFreeGiftDataList &&
    freeGiftDataList &&
    freeGiftDataList.length &&
    freeGiftDataList[0].freeGiftQtuantities.sourceQty === freeGiftDataList[0].freeGiftQtuantities.targetQty &&
    freeGiftDataList[0].acPriceDiscountValue;

  $: isfreeGiftProductAvailable =
    isFreeGiftDataList && freeGiftDataList && freeGiftDataList.length && freeGiftDataList[0].freeGiftProducts !== null;

  $: acPriceDiscountAmount =
    freeGiftDataList?.length > 0 && freeGiftDataList[0]?.acPriceDiscountValue !== null
      ? `<strong>${formatNumber(freeGiftDataList[0]?.acPriceDiscountValue?.value)}</strong>`
      : 0;
  $: freeGiftAmount =
    freeGiftDataList?.length > 0 && freeGiftDataList[0]?.freeGiftWorth !== null
      ? `<strong>${formatNumber(freeGiftDataList[0]?.freeGiftWorth)}</strong>`
      : 0;
  $: giftProducts =
    isFreeGiftDataList && freeGiftDataList?.length
      ? freeGiftDataList.flatMap(gift => gift?.freeGiftProducts || []).filter(Boolean)
      : [];
  $: isSelectionCardVisible =
    isFreeGiftDataList &&
    isfreeGiftProductAvailable &&
    (isDiscountAvailable ||
      (freeGiftDataList && freeGiftDataList.length > 1) ||
      (freeGiftDataList.length === 1 &&
        freeGiftDataList[0].freeGiftQtuantities.sourceQty !== freeGiftDataList[0].freeGiftQtuantities.targetQty));
  $: selectedGiftCodes = Array.isArray($selectedGifts)
    ? $selectedGifts.filter(code => code && code !== 'discount').map(code => String(code).replace(/~\d*$/, ''))
    : [];
  $: activeGiftGroupIndex = $selectedGiftGroup > -1 ? $selectedGiftGroup : 0;
  $: selectedGiftGroupData = freeGiftDataList?.[activeGiftGroupIndex];
  $: selectedGiftProducts =
    selectedGiftCodes.length > 0
      ? (selectedGiftGroupData?.freeGiftProducts || []).filter(product => selectedGiftCodes.includes(product?.code))
      : [];
  $: isGiftSelectionComplete =
    selectedGiftCodes.length > 0 &&
    selectedGiftGroupData?.freeGiftQtuantities?.sourceQty > 0 &&
    selectedGiftCodes.length >= selectedGiftGroupData?.freeGiftQtuantities?.sourceQty;
  $: isSelectableGiftSet =
    isFreeGiftDataList &&
    freeGiftDataList?.length > 0 &&
    (freeGiftDataList.length > 1 ||
      freeGiftDataList.some(gift => gift?.freeGiftQtuantities?.sourceQty < gift?.freeGiftQtuantities?.targetQty) ||
      freeGiftDataList.some(gift => gift?.acPriceDiscountValue && gift?.freeGiftProducts !== null));
  $: displayGiftProducts = selectedGiftProducts.length > 0 ? selectedGiftProducts : giftProducts;
  $: showSelectedGiftList = isGiftSelectionComplete && displayGiftProducts.length > 0;

  function getGiftImage(url: string) {
    if (!url) return '';
    return url.includes('?') ? `${url}&fmt=auto&w=120&h=120` : `${url}?fmt=auto&w=120&h=120`;
  }
</script>

<section class="gift-container {!isFreeGiftDataList ? 'freegift-outof-stock' : ''}">
  <div class="gift-div">
    {#if !isFreeGiftDataList}
      <div>{freeGiftDataList}</div>
    {:else if isSelectionCardVisible && !showSelectedGiftList}
      <div class="gift-select-card" data-bs-toggle="modal" data-bs-target="#giftModal">
        <div class="gift-select-left">
          <div class="gift-icon-circle">
            <Icon glyph="gift" type="png" mobileSize={30} desktopSize={30} />
          </div>
          <div class="gift-select-text">
            <span class="gift-select-text-normal"
              ><Text
                key="extra.pdp.select.gift.from.list.message"
                args={[`<b>${freeGiftDataList[activeGiftGroupIndex].freeGiftQtuantities.sourceQty}</b>`]}
              /></span
            >
            <Icon
              type="font"
              glyph={lang === 'en' ? 'chevron_right' : 'chevron_left'}
              mobileSize={18}
              desktopSize={18}
            />
          </div>
        </div>
        <div class="gift-select-plus">
          <Icon glyph="icon-plus-circle" type="primary" mobileSize={18} desktopSize={18} />
        </div>
      </div>
    {:else if displayGiftProducts.length > 0}
      <div class="gift-items-list">
        {#each displayGiftProducts as product}
          <div class="gift-item">
            <div class="gift-item-left">
              <img class="gift-thumb" src={getGiftImage(product.amplienceProductBaseUrl)} alt={product.name} />
              <div class="gift-item-copy">
                <div class="gift-name">{product.name}</div>
                <a href={product.url}>
                  <div class="gift-details-link">
                    <Text key="extra.pdp.gift.details.message" />
                    <Icon
                      type="font"
                      glyph={lang === 'en' ? 'chevron_right' : 'chevron_left'}
                      mobileSize={16}
                      desktopSize={16}
                    />
                  </div>
                </a>
              </div>
            </div>
            <div class="gift-price">
              <div class="free-text"><Text key="extra.pdp.gift.price.free.message" /></div>
              <div class="old-price">
                {@html globalCurrencyTag}
                {formatNumber(product?.price?.formattedValue || product?.price?.value || 0)}
              </div>
            </div>
          </div>
        {/each}
        {#if showSelectedGiftList && isSelectableGiftSet}
          <div class="gift-change-selection" data-bs-toggle="modal" data-bs-target="#giftModal">
            <Text key="extra.pdp.gift.change.selection.message" />
          </div>
        {/if}
      </div>
    {:else}
      <Icon glyph="gift" type="png" mobileSize={16} desktopSize={24} />
      {#if (isDiscountAvailable || (freeGiftDataList && freeGiftDataList.length > 1) || (freeGiftDataList.length === 1 && freeGiftDataList[0].freeGiftQtuantities.sourceQty !== freeGiftDataList[0].freeGiftQtuantities.targetQty)) && isfreeGiftProductAvailable}
        <span class="description"
          >{$_(getStr('extra.pdp.gift.options.free.gifts'))}
          {$_(getStr('extra.pdp.gift.options.from.selection.list'))}</span
        >
        <span class="view-gifts-text">{$_(getStr('extra.pdp.gift.options.select.gifts'))}</span>
      {:else}
        <span class="description"
          >{$_(getStr('extra.pdp.gift.options.free.gifts'))}
          {freeGiftDataList[0]?.freeGiftQtuantities?.sourceQty}
          {$_(getStr('extra.pdp.gift.options.gifts.worth'))}
          {#if isDiscountAvailable && !isfreeGiftProductAvailable}
            <Text key="jood.price.with.currency" args={[globalCurrencyTag, `${acPriceDiscountAmount}`]} />
          {:else}
            <Text key="jood.price.with.currency" args={[globalCurrencyTag, `${freeGiftAmount}`]} />
          {/if}
        </span>
        <span class="view-gifts-text">{$_(getStr('extra.pdp.gift.options.view.gifts'))}</span>
      {/if}
    {/if}
  </div>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .gift-container {
    background-color: transparent;
    padding: 0;
    cursor: pointer;
    &.freegift-outof-stock {
      background: #fffde6;
      border: solid 1px $functional-yellow;
      border-radius: 8px;
      color: $neutral-dark-01;
      font-size: 13px;
      font-weight: 500;
      line-height: 16px;
      padding: 12px;
    }

    .gift-div {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;

      .gift-items-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      .gift-change-selection {
        display: flex;
        justify-content: flex-end;
        align-items: end;
        height: 20px;
        color: $primary-blue;
        font-size: 12px;
        line-height: 14px;
        font-weight: 500;
      }
      .gift-item {
        background: $primary-white;
        border-radius: 10px;
        padding: 4.5px 16px 4.5px 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
      }
      .gift-item-left {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        flex-grow: 1;
      }
      .gift-thumb {
        width: 58px;
        height: 58px;
        object-fit: contain;
        flex-shrink: 0;
      }
      .gift-item-copy {
        min-width: 0;
      }
      .gift-name {
        color: $neutral-dark-01;
        font-size: 14px;
        line-height: 16px;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .gift-details-link {
        color: $primary-blue;
        margin-top: 6px;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        line-height: 14px;
        font-weight: 500;
      }
      .gift-price {
        text-align: right;
        flex-shrink: 0;
      }
      .free-text {
        color: $functional-green-01;
        font-size: 14px;
        line-height: 16px;
        font-weight: 700;
      }
      .old-price {
        color: $neutral-dark-03;
        font-size: 12px;
        line-height: 14px;
        margin-top: 4px;
        text-decoration: line-through;
      }

      .gift-select-card {
        width: 100%;
        border: 1px dashed $primary-blue;
        border-radius: 10px;
        padding: 11.5px 14px;
        background: $primary-white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }
      .gift-select-left {
        display: flex;
        align-items: center;
        gap: 12px;
      }
      .gift-icon-circle {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background: $neutral-light-04;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .gift-select-text {
        color: $primary-blue;
        display: inline-flex;
        align-items: center;
        gap: 4px;
      }
      .gift-select-text-normal {
        font-size: 14px;
        line-height: 18px;
        font-weight: 500;
        :global(b) {
          font-size: 18px;
          line-height: 20px;
          font-weight: 700;
        }
      }
      .gift-select-plus {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        font-size: 26px;
        line-height: 20px;
        font-weight: 700;
        text-align: center;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        :global(.primary-icon),
        :global(.primary-icon use) {
          color: $primary-blue;
          fill: $primary-blue;
        }
      }

      .description {
        color: $neutral-dark-01;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        @include desktop-min-width {
          font-size: 16px;
          line-height: 18px;
        }
      }
      .view-gifts-text {
        color: $primary-blue;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        text-decoration: none;
        white-space: nowrap;
        cursor: pointer;
        margin: 0 4px;
      }
    }
  }
</style>
